import React, { memo } from 'react';
import block from 'bem-cn';
import isEqual from 'lodash.isequal';

import { PragmaticDGAMegaRoulette } from 'components/slots/PragmaticDGA/hooks';

import './MegaRoulette.scss';

type MegaRouletteProps = {
  results: PragmaticDGAMegaRoulette['last20Results'];
}

const b = block('pragmatic-dga-mega-roulette');

export const MegaRoulette = memo(({ results }: MegaRouletteProps) => (
  <div className={b()}>
    {results.map(({ color, slots, result }, index) => {
      const isMultiplier = result in slots;
      return (
      <div key={index} className={b('bet', { color, multiplier: isMultiplier })}>
        {isMultiplier && <div className={b('multiplier')}>x{slots[result]}</div>}
        <div className={b('result')}>{result}</div>
      </div>
    )})}
  </div>
), isEqual);
